import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrManager } from 'ng6-toastr-notifications';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService, SharedserviceService } from 'src/app/services';
declare var $: any;

@Component({
  selector: 'app-offers',
  templateUrl: './offers.component.html',
  styleUrls: ['./offers.component.scss']
})
export class OffersComponent implements OnInit {
  data:any;keys:any;public page: number = 1;start = 0;msg:any
  ccData:any;
  TotalCount:any;
  totalpage:any;
  total: any;
  element:any;
  travellers: FormGroup;
  searchForm: FormGroup;
  offerList:any;
  DataReturn:any;
  combine:any=[];
  constructor(
    private activatedRoute: ActivatedRoute,
    public sharedService: SharedserviceService,
    public commonService:CommonService,
    private ngxLoader: NgxUiLoaderService,
    private toastr: ToastrManager,
    private fb: FormBuilder,
    public router: Router,
  ) { }

  ngOnInit() {
    this.offersListOneway();
    this.offersListReturn();

    this.searchForm = this.fb.group({
      adult: 1,
      child: 0,
      infant: 0
    })
    this.travellers = this.fb.group({
      adult: ['1'],
      child: ['0'],
      infant: ['0'],
    });
  }


  offersListOneway(){
    this.ngxLoader.start();
    var sedData = {
      name :""
    }
    this.sharedService.post('v1/search_offer_flight/sectors_list_oneway',sedData).subscribe((res)=> {
    // this.sharedService.post('v1/search_offer_flight/sectors_fligth_type',sedData).subscribe((res)=> {
      if(res.replyCode == 'success'){
        (res.data).forEach(element => {
          this.combine.push(element)          
          this.combine.sort((a,b) => a.departure_city_name.localeCompare(b.departure_city_name));
        });
        this.data = res.data;
        this.ccData=res.data;
        console.log('sunil:::::::',this.ccData)
        // this.keys = Object.keys(this.data[0]);
        // this.TotalCount = res.totalRecords
        // this.totalpage=res.totalPage
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }


  offersListReturn(){
    this.ngxLoader.start();
    var sedData = {
      name :""
    }
    this.sharedService.post('v1/search_offer_flight/sectors_list_return',sedData).subscribe((res)=> {
      if(res.replyCode == 'success'){

        (res.data).forEach(element => {
          this.combine.push(element)          
          this.combine.sort((a,b) => a.departure_city_name.localeCompare(b.departure_city_name));
        });
        this.DataReturn = res.data
        console.log("ReturnData::::::",this.DataReturn);
        // this.ccData=res.data;
        this.ngxLoader.stop();
      }else{
        this.ngxLoader.stop();
        this.toastr.errorToastr(res.replyMsg, 'Error');
      }
    },err=>{
      this.ngxLoader.stop();
      this.toastr.errorToastr(err.error.replyMsg, 'Error');
    });
  }


  checkOffer(list){
  // checkOffer(list,type){
    $('#totalpassengers').modal('show');
    console.log("offerList Data",list);
    this.offerList=list;
    sessionStorage.setItem("offerDetail", JSON.stringify(this.offerList));
    // sessionStorage.setItem("offerType", JSON.stringify(type));
  }

  traveller() {
    var adult = this.travellers.value.adult;
    var child = this.travellers.value.child;
    var infant = this.travellers.value.infant;

    if (adult != '' && child != '' && infant != '') {
      if (parseInt(adult) >= parseInt(infant)) {
        this.total = parseInt(adult) + parseInt(child) + parseInt(infant);

        this.searchForm.patchValue({
          adult: parseInt(adult),
          child: parseInt(child),
          infant: parseInt(infant)
        });

        $('#totalpassengers').modal('hide');
        this.searchForm.patchValue({ travellers: this.total });
        console.log("Total travlers:::::", this.searchForm.value);
        sessionStorage.setItem("travlerDetail", JSON.stringify(this.searchForm.value));
        this.router.navigateByUrl("/offer-view");
      } else {
        alert('Please select infant less than adult');
      }

    } else {
      alert('All Field is required');
    }
  }

}
